<template>
  <div class="ModalsController">
    <component
      :is="modal"
      v-for="modal in modalsOpen"
      :ref="modal"
      :key="modal"
    />
    <confirm-delete />
  </div>
</template>

<script>
import interfaceTour from '@/components/modals/ModalInterfaceTour'
import matrixPreview from '@/components/modals/ModalMatrixPreview'
import ConfirmDelete from '@/components/modals/ConfirmDelete'
import editorHelp from '@/components/modals/ModalEditorHelp'
import changePassword from '@/components/modals/ModalChangePassword'
import confirmLandscape from '@/components/modals/ConfirmLandscapeInvitation'
import billingNext from '@/components/modals/ModalBillingNext'
import businessContact from '@/components/modals/ModalBusinessContact.vue'
import startPage from '@/components/modals/ModalStartPage.vue'
import digest from '@/components/modals/ModalDigest'
import editActor from '@/components/modals/ModalEditActor.vue'
import editComment from '@/components/modals/ModalEditComment.vue'
import editFeedSource from '@/components/modals/ModalEditFeedSource.vue'
import editInsight from '@/components/modals/ModalEditInsight'
import editInsightComment from '@/components/modals/ModalEditInsightComment'
import editPremise from '@/components/modals/ModalEditPremise'
import editPremiseComment from '@/components/modals/ModalEditPremiseComment'
import editTopic from '@/components/modals/ModalEditTopic'
import feedback from '@/components/modals/ModalFeedback.vue'
import filterFeeds from '@/components/modals/ModalFilterFeeds'
import globalSourceFilters from '@/components/modals/ModalGlobalSourceFilters'
import freePlan from '@/components/modals/ModalFreePlan'
import manager from '@/components/modals/ModalManager'
import moveActor from '@/components/modals/ModalMoveActor.vue'
import moveTopics from '@/components/modals/ModalMoveTopics.vue'
import mergeActor from '@/components/modals/ModalMergeActor.vue'
import mergeTags from '@/components/modals/ModalMergeTags.vue'
import upsertTag from '@/components/modals/ModalUpsertTag.vue'
import squashActor from '@/components/modals/ModalSquashActor.vue'
import newAccesoSource from '@/components/modals/ModalNewAccesoSource'
import newActor from '@/components/modals/ModalNewActor.vue'
import newFeedChannel from '@/components/modals/ModalNewFeedChannel'
import newFeedPipe from '@/components/modals/ModalNewFeedPipe'
import newFeedSource from '@/components/modals/ModalNewFeedSource.vue'
import newSearchSource from '@/components/modals/ModalNewSearchSource'
import newsletterSignup from '@/components/modals/ModalNewsletter.vue'
import newInsight from '@/components/modals/ModalNewInsight'
import newAxis from '@/components/modals/ModalNewAxis'
import newLandscape from '@/components/modals/ModalNewLandscape.vue'
import newPremise from '@/components/modals/ModalNewPremise'
import newTopic from '@/components/modals/ModalNewTopic.vue'
import newTopicFromFeed from '@/components/modals/ModalNewTopicFromFeed.vue'
import premiumPlan from '@/components/modals/ModalPremiumPlan'
import actorProfile from '@/components/modals/ModalActorProfile'
import topic from '@/components/modals/ModalTopic.vue'
import topicFromUrl from '@/components/modals/ModalTopicFromUrl'
import topicsSearcher from '@/components/modals/ModalTopicsSearcher'
import topicToInsight from '@/components/modals/ModalTopicToInsight'
import topicToPremise from '@/components/modals/ModalTopicToPremise'
import upgradePlan from '@/components/modals/ModalUpgradePlan'
import userList from '@/components/modals/ModalUserList'
import mentionList from '@/components/modals/ModalMentionList'
import whatsNew from '@/components/modals/ModalWhatsNew'
import {ModalType, Events} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import {isEmpty} from 'lodash'
import Vue from 'vue'

export default {
  name: 'ModalsController',
  components: {
    ConfirmDelete,
    interfaceTour,
    matrixPreview,
    editorHelp,
    changePassword,
    confirmLandscape,
    newLandscape,
    topicToPremise,
    editPremiseComment,
    editPremise,
    newPremise,
    newFeedChannel,
    topicToInsight,
    manager,
    filterFeeds,
    globalSourceFilters,
    newAccesoSource,
    topicFromUrl,
    editInsightComment,
    editInsight,
    topicsSearcher,
    newInsight,
    digest,
    whatsNew,
    upgradePlan,
    billingNext,
    feedback,
    businessContact,
    actorProfile,
    editTopic,
    moveTopics,
    editComment,
    startPage,
    newActor,
    editActor,
    moveActor,
    mergeActor,
    mergeTags,
    upsertTag,
    squashActor,
    topic,
    newTopic,
    userList,
    mentionList,
    newFeedSource,
    newSearchSource,
    newsletterSignup,
    newFeedPipe,
    editFeedSource,
    newTopicFromFeed,
    newAxis,
    freePlan,
    premiumPlan
  },
  data() {
    return {
      modalsOpen: {}
    }
  },
  watch: {
    $route(to, from) {
      if (!isEmpty(to.query)) this.openModal(to.query)
      if (!isEmpty(from.query)) this.closeModal(to.query, from.query)
    }
  },
  mounted() {
    EventHub.on(Events.MODAL_CLOSED, this.removeModal)
    const q = this.$router.currentRoute.query
    if (!isEmpty(q)) this.openModal(q)
  },
  methods: {
    openModal(tq) {
      for (let type in tq) {
        if (this.isModal(type)) {
          let key = null
          switch (type) {
            case ModalType.MODAL:
            case ModalType.SUBMODAL:
              key = tq[type]
              break
            case ModalType.TOPIC:
            case ModalType.EDIT_FEED_SOURCE:
            case ModalType.FILTER_FEEDS:
              key = type
              break
          }
          if (key && !this.modalIsOpen(key)) {
            Vue.set(this.modalsOpen, key, key)
          }
        }
      }
    },
    closeModal(tq, fq) {
      for (let type in fq) {
        if (fq[type] && !tq[type] && this.isModal(type)) {
          EventHub.emit(Events.CLOSE_MODAL, type)
        }
      }
    },
    removeModal(modalName) {
      Vue.delete(this.modalsOpen, modalName)
    },
    isModal(modalType) {
      for (let key in ModalType) {
        const type = ModalType[key]
        if (modalType === type) return true
      }
      return false
    },
    modalIsOpen(modal) {
      return this.modalsOpen.hasOwnProperty(modal)
    }
  }
}
</script>
